











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {BaseFretebasEmpresa} from '@/model/resource/BaseFretebasEmpresa'
import {BaseFretebasEmpresaCollection} from '@/model/collection/BaseFretebasEmpresaCollection'
import {ListBaseFretebasEmpresaSchema} from '@/schema/resource/BaseFretebasEmpresa/ListBaseFretebasEmpresaSchema'
import {CsvBaseFretebasEmpresaSchema} from '@/schema/resource/BaseFretebasEmpresa/CsvBaseFretebasEmpresaSchema'

@Component
export default class ListBaseFretebasEmpresaView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListBaseFretebasEmpresaSchema()
  collection = new BaseFretebasEmpresaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: BaseFretebasEmpresa) {
    Helper.pushByName('editBaseFretebasEmpresa', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new BaseFretebasEmpresaCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvBaseFretebasEmpresa()
    new CsvBaseFretebasEmpresaSchema().downloadCsv(csv.all())
  }
}
